import styled from "styled-components";

export const DrugInteractionContainer = styled.div`
  max-width: 42rem;
  margin: auto;
  margin-bottom: ${({ theme }) => theme.space.xxxl};
`;
